document.addEventListener("DOMContentLoaded", function () {
  let isUpdating = false;

  /**
   * CRITICAL: Update Custom Button Function
   * This synchronizes the main "Add to Cart" button with the currently active product
   * 
   * Flow:
   * 1. Find the active product (li.active-product) in the current tab/panel
   * 2. Clone its .quick-add form/button
   * 3. Update all IDs by appending "-custom" to avoid conflicts
   * 4. Replace the custom button wrapper's content with the cloned button
   * 
   * Why: Allows a single prominent button that always adds the selected product,
   * even as users switch between different product options (1 month, 3 months, etc.)
   */
  function updateCustomButton() {
    if (isUpdating) return;
    isUpdating = true;

    try {
      const customButtonWrappers = document.querySelectorAll(
        ".custom-button-wrapper"
      );

      customButtonWrappers.forEach((wrapper) => {
        const section = wrapper.closest(".section");

        // First try to find active product in tabbed panels
        let activeProduct = section.querySelector(
          ".tabbed-product-block__panel--active li.active-product"
        );

        // If not found in tabbed panels, look for any active product
        if (!activeProduct) {
          activeProduct = section.querySelector("li.active-product");
        }

        if (activeProduct) {
          const quickAddButton = activeProduct.querySelector(".quick-add");

          if (quickAddButton) {
            const clonedButton = quickAddButton.cloneNode(true);

            const forms = clonedButton.querySelectorAll("form");
            const buttons = clonedButton.querySelectorAll("button");
            const modals = clonedButton.querySelectorAll("quick-add-modal");
            const modalOpeners = clonedButton.querySelectorAll("modal-opener");

            forms.forEach((form) => {
              const oldId = form.id;
              if (oldId) {
                form.id = oldId + "-custom";
              }
              // Ensure the form has the correct data-type for upsell detection
              form.setAttribute("data-type", "add-to-cart-form");
            });

            buttons.forEach((button) => {
              const oldId = button.id;
              if (oldId) {
                button.id = oldId + "-custom";
              }
              const ariaLabelledBy = button.getAttribute("aria-labelledby");
              if (ariaLabelledBy) {
                button.setAttribute(
                  "aria-labelledby",
                  ariaLabelledBy + "-custom"
                );
              }
            });

            modals.forEach((modal) => {
              const oldId = modal.id;
              if (oldId) {
                modal.id = oldId + "-custom";
              }
            });

            modalOpeners.forEach((opener) => {
              const dataModal = opener.getAttribute("data-modal");
              if (dataModal) {
                opener.setAttribute("data-modal", dataModal + "-custom");
              }
            });

            // Apply custom button text if set via Theme Editor
            const customText = wrapper.getAttribute("data-button-text");
            if (customText) {
              const submitBtn = clonedButton.querySelector(".quick-add__submit");
              if (submitBtn) {
                const textSpan = submitBtn.querySelector("span:not(.sold-out-message)");
                if (textSpan) {
                  textSpan.textContent = customText;
                }
              }
            }

            wrapper.innerHTML = "";
            wrapper.appendChild(clonedButton);
          }
        }
      });
    } catch (error) {
      console.error("Error updating custom button:", error);
    } finally {
      isUpdating = false;
    }
  }

  // Initialize on page load
  updateCustomButton();

  /**
   * CRITICAL: Click Event Listener
   * Triggers button update when user clicks a product option
   * Detected by data-index attribute or specific CSS classes
   * Uses requestAnimationFrame for smooth DOM updates
   */
  document.addEventListener("click", function (e) {
    const clickedProduct =
      e.target.closest("li[data-index]") ||
      e.target.closest(".subOption") ||
      e.target.closest("li.animate--slide-in") ||
      e.target.closest(".tabbed-product-block__button");

    if (clickedProduct) {
      requestAnimationFrame(() => {
        updateCustomButton();
      });
    }
  });

  document.addEventListener("tabChanged", function (e) {
    requestAnimationFrame(() => {
      updateCustomButton();
    });
  });

  /**
   * CRITICAL: Mutation Observer for Active Product Class Changes
   * Watches all product list items (li[data-index]) for class changes
   * When .active-product class is added/removed, triggers button update
   * 
   * Why: Ensures button stays synced even when active state changes
   * via JavaScript (not just click events)
   */
  const productItems = document.querySelectorAll("li[data-index]");
  if (productItems.length > 0) {
    const observer = new MutationObserver(function (mutations) {
      let shouldUpdate = false;

      mutations.forEach(function (mutation) {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "class" &&
          (mutation.target.classList.contains("active-product") ||
            mutation.oldValue?.includes("active-product"))
        ) {
          shouldUpdate = true;
        }
      });

      if (shouldUpdate) {
        requestAnimationFrame(() => {
          updateCustomButton();
        });
      }
    });

    productItems.forEach((item) => {
      observer.observe(item, {
        attributes: true,
        attributeFilter: ["class"],
        attributeOldValue: true,
      });
    });
  }
});
